<template>
    <div class="d-flex principal">
        <button type="button" class="botao btnSubChamados" @click="realizarChamado(tpChamListSub)" data-bs-dismiss="modal"
            :style="{ backgroundColor: tpChamado.cor, color: tpChamado.fonte, borderColor: tpChamado.borda }">
            <img :src="require(`@/../imagens/${tpChamado.id}-icone.svg`)">
            <p class="descricao"> {{ tpChamListSub.descricao }} </p>
        </button>
    </div>
</template>

<script setup>
import { onMounted, reactive, defineProps, defineEmits } from 'vue';
const props = defineProps(['tpChamado', 'tpChamListSub']);
const emits = defineEmits(['realizarChamado']);

function realizarChamado(tpChamListSub) {
    emits('realizarChamado', tpChamListSub);
}
</script>

<style scoped>
.principal {
    align-items: center;
    justify-content: space-between;
}

.circulo {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    float: center;
    /* margin-top: 15px;
    margin-bottom: 15px; */
    margin: 15px 20px;
    cursor: pointer;
    align-self: end;
}

.descricao {
    text-align: left;
    margin: 0;
    font-size: 1.5rem;
}

.btnSubChamados {
    border: 4px solid;
    width: 95% !important;
}
</style>